<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Deductions List</h3>
          <span class="float-right">
            <button type="button" class="btn btn-success" @click="newModal" ><i class="fa fa-plus"></i></button>
          </span>

          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
          <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'Status'">
                    <span
                      v-if="props.row.status == 'active'"
                      class="label label-success"
                      >Active</span
                    >
                    <span v-else class="label label-danger">InActive</span>
                  </span>
                  <span v-if="props.column.field == 'id'">
                    <button
                      type="button"
                      @click="editModal(props.row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Deductions
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>

      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h4 v-show="!editMode" class="modal-title">Add New Head</h4>
              <h4 v-show="editMode" class="modal-title">Update Head</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent.once="editMode ? editHead() : createHead()">
              <div class="modal-body">
                <!-- right column -->
                <div class="col-md-12">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label> Head <span class="red">*</span></label>
                            <input
                              v-model="form.head"
                              type="text"
                              name="head"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('head') }"
                            />
                            <has-error :form="form" field="head"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Head Type <span class="red">*</span></label>
                            <select
                              v-model="form.type"
                              name="type"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('type') }"
                            >
                              <option v-if="!form.type" selected value="">
                                Select Head Type
                              </option>
                              <option value="additional">Additional</option>
                              <option value="deduction">Deduction</option>
                            </select>
                            <has-error :form="form" field="type"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option v-if="!form.status" selected value="">
                                Select Status
                              </option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success btn-sm"
                >
                  SAVE
                </button>
                <button
                  v-show="editMode"
                  type="submit"
                  class="btn btn-info btn-sm"
                >
                  UPDATE
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      
</div>
</template>

<script>
export default {
  name: 'DeductionMaster',
  data () {
    return {
      editMode: false,
      form: new Form({
        id: '',
        head: '',
        type: '',
        status: ''
      }),
      columns: [
        {
          label: 'HEAD',
          field: 'head'
        },

        {
          label: 'TYPE',
          field: 'type'
        },

        {
          label: 'STATUS',
          field: 'Status'
        },

        {
          label: 'ACTIONS',
          field: 'id',
          type: 'number'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      $('#newModal').modal('show')
    },
    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#newModal').modal('show')
      this.form.fill(row)
    },
    createHead () {
      this.$axios
        .post('head', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Head Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    editHead () {
      this.$axios
        .put('head/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Head Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      let loader = this.$loading.show()
      this.$axios
        .get('head?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// DeductionMaster.vue?6418be6d